export default __webpack_public_path__ + "static/media/happy.fa7170ed.jpeg";